export default "/images/d848d6536743d2b439b9f5d4e4fc1dd9.avif";